import React from 'react';
import { useAdmin } from '../../context/AdminContext';
import styles from './AdminTenantList.module.css';

const AdminTenantList: React.FC = () => {
  const { tenants, selectedTenant, loadingTenants, selectTenant } = useAdmin();

  if (loadingTenants) {
    return (
      <div className={styles['admin-tenant-list']}>
        <h3>Tenants</h3>
        
        <div className={styles['tenant-list']}>
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className={styles['tenant-item-skeleton']}>
              <div className={styles['skeleton-header']}>
                <div className={styles['skeleton-name']}></div>
                <div className={styles['skeleton-id']}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles['admin-tenant-list']}>
      <h3>Tenants ({tenants.length})</h3>
      
      <div className={styles['tenant-list']}>
        {tenants.map((tenant) => (
          <div
            key={tenant.id}
            className={`${styles['tenant-item']} ${selectedTenant?.id === tenant.id ? styles.selected : ''}`}
            onClick={() => selectTenant(tenant)}
          >
            <div className={styles['tenant-header']}>
              <div className={styles['tenant-name']}>{tenant.name}</div>
              <div className={styles['tenant-id']}>ID: {tenant.id}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminTenantList;
